import React, { useEffect } from "react"
import AwesomeDebouncePromise from "awesome-debounce-promise"

const postWindowMessage = async (reason="unknown") => {

  if (typeof window !== "undefined") {
    //wrapper of scrolling sponsored content
    let contentSizes = document.querySelector("main.sponsored").getBoundingClientRect()
    let frameWidth = contentSizes.width
    let frameHeight = contentSizes.height
    console.log(`posting the following to parent: frameWidth: ${frameWidth}, frameHeight: ${frameHeight}. event fired because: ${reason}`)
    if (window.parent) {
      window.parent.postMessage("frameWidth:" + frameWidth, "*")
      window.parent.postMessage("frameHeight:" + frameHeight, "*")
    }
  }
}
const postMessageDebounced = AwesomeDebouncePromise(postWindowMessage, 250)
const IframeMagick = () => {
  useEffect(() => {
    postMessageDebounced("'onload' event fired")
    const withArgs = () => postMessageDebounced("resize event fired (debounced 250ms)")
    window.addEventListener("resize", withArgs)
    return () => {
      window.removeEventListener("resize", withArgs)
    }
  }, [])
  return <></>
}

export default IframeMagick
